import ScholarlyIq from './scholarlyIq';
import { TemporaryStorageService } from '@imaios-js/utils';
import { STORAGE_KEY } from '@assets/js/imaios-connection-management/config.constant';
import LoginManagementService from '@assets/js/imaios-connection-management/login-management-service';

window.addEventListener('load', async function (e) {
  const scholarlyIq = new ScholarlyIq();
  const event_type = imaios.get('scholarlyiq.event_type');
  const database = imaios.get('scholarlyiq.database');
  const doi = imaios.get('scholarlyiq.doi');
  const yop = imaios.get('scholarlyiq.yop');

  await LoginManagementService.awaitConnection();
  /** @type {LocalUserData}*/
  const information = TemporaryStorageService.get(STORAGE_KEY.IMAIOS_USER_INFORMATION);
  if (information) {
    void scholarlyIq.getSiqInformation(event_type, database, doi, yop, information);
  }
});
